import { ChangeEvent, FC } from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background-color: ${color.grayscale[1000]};
    border-radius: 60px;
    box-shadow: ${shadow.dialog};
    padding: 4px;
    display: inline-flex;
    gap: 0.5rem;
  `;
});

const Radio = styled.input(({ theme }) => {
  const { color, type } = theme;

  return `
    position: absolute;
    left: -9999px;
    top: 0;

    & + label {
      border-radius: 37px;
      background-color: ${'transparent'};
      color: ${color.grayscale[200]};
      padding: 7.5px 16px;
      font-size: ${type.size.small};
      font-weight: ${type.weight.bold};
      cursor: pointer;
      transition: color 200ms ease-in-out, background-color 200ms ease-in-out;
      margin-bottom: 0;

      &:hover {
        background-color: ${color.grayscale[800]};
      }
    }

    &:checked + label {
      background-color: ${color.secondary.regular};
      color: ${color.grayscale[1000]};
      cursor: default;
    }

    &:focus-visible + label {
      outline: 2px auto -webkit-focus-ring-color;
    }
  `;
});

export interface ISessionToggle {
  options: [{ value: string; label: string }];
  callback: (value: string) => void;
  selected: string;
  className: string;
}

const SessionToggle: FC<ISessionToggle> = ({ options, callback, selected, className }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    callback(value);
  };

  const radioLoop = options.map((option) => {
    const { label, value } = option;

    return (
      <div key={value}>
        <Radio
          type="radio"
          id={`sessionToggle-${value}`}
          name="sessionToggle"
          value={value}
          checked={selected === value}
          onChange={handleChange}
        />
        <label htmlFor={`sessionToggle-${value}`}>{label}</label>
      </div>
    );
  });
  return <Container className={className}>{radioLoop}</Container>;
};

export default SessionToggle;
